const AVATAR_PALETTES = [
  { bg: "#EDE8F5", color: "#46109B" },
  { bg: "#D1FAE5", color: "#065F46" },
  { bg: "#FEF3C7", color: "#92400E" },
  { bg: "#FEE2E2", color: "#991B1B" },
  { bg: "#DBEAFE", color: "#1E40AF" },
  { bg: "#FCE7F3", color: "#9D174D" },
];

export function getInitials(name) {
  if (!name) return "?";
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function pickAvatarPalette(seed = "") {
  let hash = 0;
  const s = String(seed);
  for (let i = 0; i < s.length; i += 1) {
    hash = (hash + s.charCodeAt(i) * (i + 1)) % AVATAR_PALETTES.length;
  }
  return AVATAR_PALETTES[hash];
}

export function invitationStatusBadge(status) {
  switch (status) {
    case "Accepted":
      return { variant: "green", label: "Confirmed" };
    case "Rejected":
      return { variant: "red", label: "Declined" };
    case "Unseen":
      return { variant: "amber", label: "Pending" };
    default:
      return { variant: "gray", label: status || "Unknown" };
  }
}

export function messageStatusBadge(messageStatus) {
  if (!messageStatus || messageStatus === "not sent") {
    return { variant: "amber", label: "Not sent" };
  }
  if (messageStatus === "failed") {
    return { variant: "red", label: "Failed" };
  }
  if (messageStatus === "delivered" || messageStatus === "read") {
    return { variant: "green", label: messageStatus === "read" ? "Read" : "Delivered" };
  }
  if (messageStatus === "sent") {
    return { variant: "blue", label: "Sent" };
  }
  return { variant: "gray", label: messageStatus };
}

export function emailStatusBadge(emailStatus) {
  if (!emailStatus || emailStatus === "not sent") {
    return { variant: "amber", label: "Not sent" };
  }
  if (emailStatus === "failed") {
    return { variant: "red", label: "Failed" };
  }
  if (emailStatus === "delivered") {
    return { variant: "green", label: "Delivered" };
  }
  if (emailStatus === "opened") {
    return { variant: "green", label: "Opened" };
  }
  if (emailStatus === "clicked") {
    return { variant: "purple", label: "Clicked" };
  }
  if (emailStatus === "sent") {
    return { variant: "blue", label: "Sent" };
  }
  if (emailStatus === "deferred") {
    return { variant: "amber", label: "Deferred" };
  }
  return { variant: "gray", label: emailStatus };
}
